import { connect } from 'react-redux';
import { fetchSidenav, fetchQCSideNav } from 'ducks/sidenav';

import { HEADER_HEIGHT, TOP_NAV_HEIGHT } from 'style/dimensions';

import { groupDefinitionsByCategory } from 'utils/dictionaryHelpers';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import SideNav from 'components/SideNav';
import withRouting from 'utils/withRouting';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useEffect } from 'react';

class Browse extends React.Component {
  componentDidMount = () => {
    const {
      dispatch,
      entityDefinitions: { defs },
      router: {
        params: { program, project },
      },
    } = this.props;

    defs.length && this.getSideNavData({
      defs,
      dispatch,
      path: this.sectionName(),
      program,
      project,
    });
  }

  componentDidUpdate = (prevProps) => {
    const {
      entityDefinitions: { defs: oldDefs },
    } = prevProps;

    const {
      dispatch,
      entityDefinitions: { defs },
      router: {
        location: { pathname },
        params: { program, project },
      },
    } = this.props;

    const oldPath = this.sectionName();
    const path = this.sectionName(pathname);

    (oldPath !== path || (!oldDefs.length && defs.length))
      && this.getSideNavData({
        defs,
        dispatch,
        path,
        program,
        project,
      });
  }

  getSideNavData = ({
    defs,
    dispatch,
    path,
    program,
    project,
  }) => {
    const projectId = `${program}-${project}`;

    path === 'qc'
      ? dispatch(fetchQCSideNav({ program, project, defs }))
      : dispatch(fetchSidenav({ projectId, defs }));
  };

  sectionName = (path) => {
    const { router: { location: { pathname } } } = this.props;
    return (path || pathname).split('/')[3];
  }

  render(): React.Element {
    const {
      entityDefinitions: { defs, isFetching },
      notifications,
      projects,
      router: {
        params,
      },
      sidenav,
    } = this.props;

    const path = this.sectionName();
    const projectId = `${params.program}-${params.project}`;
    const project = projects.items.find(p => p.project_id === projectId);

    const defsByCategory = groupDefinitionsByCategory({ defs });

    return (
      <Row>
        <Column
          style={{
            flex: 1,
            overflow: 'hidden',
            width: '100%',
          }}
          >
          <Row
            style={{
              height: `calc(100vh - ${(1 + notifications.filter(n => !n.dismissed).length) * HEADER_HEIGHT + TOP_NAV_HEIGHT}rem)`,
            }}
            >
            {defs.length > 0 && [
              <SideNav
                {...this.props}
                key="SideNav"
                isFetching={sidenav.isFetching || isFetching}
                items={defsByCategory}
                path={path}
                project={project}
                sidenav={sidenav}
                />,
            <Outlet />
            ]}
          </Row>
        </Column>
      </Row>
    );
  }
}

const BrowseWithRedirect = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lastPath = location.pathname.split('/').at(-1);
    if (lastPath === "browse") {
      navigate("../browse/case");
    }
  }, [location.pathname]);

  return (
    <Browse {...props} />
  )
}

export default connect(
  state => ({
    projects: state.projects,
    sidenav: state.sidenav,
    entityDefinitions: state.entityDefinitions,
    notifications: state.notifications,
    qcReports: state.qcReports,
  }),
)(withRouting(BrowseWithRedirect));
